import type Button from '$lib/components/atoms/button/Button.svelte';
import type { ComponentProps } from 'svelte';
import { derived, type Readable, writable } from 'svelte/store';

export interface Notification {
	message: string;
	timeout?: number;
	closable?: boolean;
	closeButton?: ComponentProps<typeof Button>;
	onCloseCallback?: () => void;
}

const defaults: Partial<Notification> = {
	timeout: 5000,
	closable: true,
};

const notifications = writable<Notification[]>([]);

export function addNotification(notification: Notification | string) {
	const n = {
		...defaults,
		...(typeof notification === 'string' ? { message: notification } : notification),
	};
	notifications.update(($notifications) => {
		$notifications.push(n);
		return $notifications;
	});
}

export function removeNotification(notification: Notification) {
	notifications.update(($notifications) => {
		const index = $notifications.findIndex(n => n === notification);
		if (index > -1) {
			$notifications.splice(index, 1);
		}
		return $notifications;
	});
}

export const notification: Readable<Notification> = derived(
	notifications,
	($notifications, set) => {
		set($notifications[0]);
	},
);
